"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedAppts = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const framer_motion_1 = require("framer-motion");
const button_1 = __importDefault(require("@kyruus/button"));
const ArrowDown_1 = __importDefault(require("@kyruus/react-ikons/ArrowDown"));
const intl_1 = require("@kyruus/intl");
const Banners_1 = require("../../Banners");
const styles_1 = require("./styles");
const utils_1 = require("../../../lib/utils");
const ApptList_utils_1 = require("./ApptList.utils");
const prop_types_2 = require("prop-types");
const messages_1 = __importDefault(require("../../../lib/messages"));
const variants = {
    initial: { y: '-20%', opacity: 0 },
    enter: { y: 0, opacity: 1 },
    exit: { y: '20%', opacity: 0 },
    open: {
        opacity: 1,
        height: 'auto',
        visibility: 'visible'
    },
    collapsed: {
        opacity: 0,
        height: 0,
        transitionEnd: {
            visibility: 'hidden'
        }
    }
};
const stickyHeaders = {
    header: {
        date: '155px',
        location: '196px'
    },
    mobileHeader: {
        date: '200px',
        location: '242px'
    }
};
const AnimatedList = react_1.default.forwardRef((props, ref) => (react_1.default.createElement(styles_1.List, Object.assign({}, props, { variants: variants, initial: "open", exit: "exit", ref: ref }))));
AnimatedList.displayName = 'AnimatedList';
const propTypes = {
    header: prop_types_1.string.isRequired,
    groupByLocId: prop_types_1.object.isRequired,
    locById: prop_types_1.object.isRequired,
    onSelectAppt: prop_types_1.func.isRequired,
    onHighlightLocId: prop_types_1.func.isRequired,
    query: prop_types_1.object.isRequired,
    shouldUseJumpToDate: prop_types_1.bool,
    apptDensity: (0, prop_types_2.oneOf)(['default', 'dense']),
    disableExpandCollapse: prop_types_1.bool,
    track: prop_types_1.func,
    shouldShowRegulatedSpacesBanner: prop_types_1.bool,
    provider: prop_types_1.object.isRequired,
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    }).isRequired
};
const GroupedAppts = ({ header, groupByLocId, locById, onSelectAppt, onHighlightLocId, query, shouldUseJumpToDate, apptDensity, disableExpandCollapse = false, track = () => { }, shouldShowRegulatedSpacesBanner = false, provider, intl }) => {
    const isVirtualVisit = (0, utils_1.hasAnyVideoPhoneAppt)(query.purpose.visit_method);
    const [isVisible, setShowAppts] = (0, react_1.useState)(true);
    const refs = (0, react_1.useRef)((isVirtualVisit ? ['0'] : Object.keys(groupByLocId)).map(() => (0, react_1.createRef)()));
    // show/hide each list section when `isVisible` changes
    (0, react_1.useEffect)(() => {
        refs.current.forEach((ref) => {
            if (ref.current) {
                const el = ref.current;
                el.style.maxHeight = isVisible ? `${el.scrollHeight}px` : 0;
            }
        });
    }, [isVisible]);
    const mappedApptSlotsData = isVirtualVisit
        ? (0, ApptList_utils_1.sortedVirtualSlotsByTime)(groupByLocId) // final result array of objects (grouped location id's data with sort by time)
        : Object.keys(groupByLocId); // final result object of objects (location id's data)
    const slotsTile = (slots, intl) => {
        return (react_1.default.createElement("li", { className: "GroupedAppt", "data-testid": "GroupedAppts__Slot", key: slots.start_datetime, onFocus: () => onHighlightLocId(slots.location_id.toString()), onBlur: () => onHighlightLocId(null), onMouseEnter: () => onHighlightLocId(slots.location_id.toString()), onMouseLeave: () => onHighlightLocId(null) },
            react_1.default.createElement(button_1.default, { id: (0, utils_1.getApptSlotId)(slots), mode: apptDensity === 'dense' ? 'primary' : 'flat', onClick: () => onSelectAppt(slots), "aria-label": intl.formatMessage(messages_1.default.ariaProviderTimeSlotDescription, {
                    providerName: (0, utils_1.formatProviderName)(provider),
                    date: (0, utils_1.formatHeaderDate)(header),
                    time: (0, utils_1.formatApptTime)(slots.start_datetime)
                }) }, (0, utils_1.formatApptTime)(slots.start_datetime))));
    };
    return (react_1.default.createElement(styles_1.ApptContainer, { "data-testid": "GroupedAppts", isVirtualVisit: isVirtualVisit },
        react_1.default.createElement(styles_1.Header, { className: "GroupedAppts__header" // used for PMC-specific styling adjustments
            , "data-testid": "GroupedAppts__header", stickyValues: shouldUseJumpToDate && stickyHeaders, disableExpandCollapse: disableExpandCollapse },
            react_1.default.createElement("h5", null, (0, utils_1.formatHeaderDate)(header)),
            !disableExpandCollapse && (react_1.default.createElement(styles_1.ArrowButton, { "aria-label": isVisible ? 'hide appointments' : 'show appointments', mode: "flat", onClick: () => setShowAppts(!isVisible), reversed: !isVisible },
                react_1.default.createElement(ArrowDown_1.default, { size: "24px" })))),
        react_1.default.createElement(framer_motion_1.AnimatePresence, null, isVirtualVisit ? (react_1.default.createElement("div", null,
            react_1.default.createElement(AnimatedList, { ref: refs.current[0], key: header, "data-testid": "GroupedAppts__Group__List", animate: isVisible ? 'open' : 'collapsed', apptDensity: apptDensity }, mappedApptSlotsData.map((locId) => slotsTile(locId, intl))))) : (mappedApptSlotsData.map((locId, index) => (react_1.default.createElement("div", { key: locId },
            react_1.default.createElement(styles_1.ListHeader, { disableExpandCollapse: disableExpandCollapse, className: "GroupedAppts__Group__header" // used for PMC-specific styling adjustments
                , "data-testid": "GroupedAppts__Group__header", stickyValues: shouldUseJumpToDate && stickyHeaders },
                react_1.default.createElement("div", { "data-testid": "location__name" }, locById[locId].name),
                react_1.default.createElement("div", { "data-testid": "location__address" }, (0, utils_1.formatLocation)(locById[locId])),
                locById[locId].facility_fee &&
                    shouldShowRegulatedSpacesBanner && (react_1.default.createElement(Banners_1.RegulatedSpacesBanner, { "data-testid": "GroupedAppts__RegulatedSpacesBanner", location: locById[locId], track: track }))),
            react_1.default.createElement(AnimatedList, { ref: refs.current[index], key: header, "data-testid": "GroupedAppts__Group__List", animate: isVisible ? 'open' : 'collapsed', apptDensity: apptDensity }, groupByLocId[locId].map((appt) => slotsTile(appt, intl))))))))));
};
exports.GroupedAppts = GroupedAppts;
exports.GroupedAppts.propTypes = propTypes;
exports.default = (0, intl_1.injectIntl)(exports.GroupedAppts);
//# sourceMappingURL=GroupedAppts.js.map